
import { isString, map, each, filter, find } from 'lodash';
import { User } from '../user/user';
import { RecordField } from '../record/record';
import { Dossier } from '../dossier/dossier';
import { Link } from '../dossier/link';

export class DataLink implements Link {
  
  id: string
  name: string
  dossier: Dossier
  fields: RecordField[] = []

  created_at: number
  created_by: User

  updated_at: number
  updated_by: User

  version: number

  __typename: string

  // View model fields
  model: any

  constructor(data: any = {}) {
    Object.assign(this, data);

    if(this.created_by) {
      this.created_by = new User(this.created_by);
    }

    if(this.updated_by) {
      this.updated_by = new User(this.updated_by);
    }

    if(this.dossier) {
      this.dossier = new Dossier(this.dossier);
    }

    if(this.fields) {
      this.fields = map(this.fields, f => new RecordField(f));
    }
  }

  replaceWith(replacement: DataLink) {
    Object.assign(this, replacement);
  }

  get valid():boolean {
    // name
    if(!isString(this.name)) {
      return false;
    }

    let trimmedName = this.name.trim();

    if(trimmedName.length > 200) {
      return false;
    }

    if(trimmedName.length === 0) {
      return false;
    }

    // fields
    let fieldsValid = true;

    each(this.fields , field => {
      if(!field.valid) {
        fieldsValid = false;
      }
    });

    if(!fieldsValid) {
      return false;
    }

    return true;
  }

  /**
   * Returns the list of fields allowed by the model
   */
  get modelFields() {
    if(!this.model) {
      return [];
    }

    return filter(this.fields, field => {
      return this.model.fields[field.name] !== undefined;
    });
  }

  toCreateDataLinkInput(dossier_id: string) {
    return {
      dossier_id,
      name: this.name,
      fields: map(this.modelFields, f => f.toRecordFieldInput()),
    };
  }

  toUpdateDataLinkInput() {
    return {
      version: this.version,
      fields: map(this.modelFields, f => f.toRecordFieldInput()),
    };
  }

  /**
   * Link interface
   */
  isRecordLink(): boolean {
    return false;
  }

  isDataLink(): boolean {
    return true;
  }

  /**
   * Extra helpers
   */
  get label(): string {
    let nameField = find<RecordField>(this.fields, field => {
      let model = find(this.model.fields, (model: any, id: string) => field.name === id);

      return model && model.is_name;
    });

    return nameField ? nameField.value : null;
  }

  lookupFieldValue(name: string): string {
    let field = find(this.fields, f => f.name === name);

    return field ? field.value : null;
  }
}
